"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Dialog = _interopRequireDefault(require("./Dialog"));

var _ReleaseNotes = _interopRequireDefault(require("../releaseNotes/ReleaseNotes"));

var setReleaseNotesItem = function setReleaseNotesItem(props) {
  window.localStorage.setItem(props.RELEASE_NOTES_ITEM, props.currentVersion);
  props.setShowReleaseNotes(false);
};

var getModuleName = function getModuleName(moduleName, whatsNew) {
  return /*#__PURE__*/_react.default.createElement("span", null, moduleName ? moduleName : whatsNew);
};

var getBody = function getBody(props) {
  var translatedReleaseNotes = props.translatedReleaseNotes;
  return /*#__PURE__*/_react.default.createElement(_ReleaseNotes.default, {
    releaseNotes: translatedReleaseNotes
  });
};

var getFooter = function getFooter(props) {
  var closeButtonText = props.closeButtonText;
  return /*#__PURE__*/_react.default.createElement("button", {
    "data-component": 'CloseButton',
    type: 'button',
    className: 'btn btn-default',
    onClick: function onClick() {
      return setReleaseNotesItem(props);
    }
  }, closeButtonText || 'Close');
};

var ReleaseNotesDialog = function ReleaseNotesDialog(props) {
  var moduleName = props.moduleName,
      whatsNewTitle = props.whatsNewTitle;
  return /*#__PURE__*/_react.default.createElement(_Dialog.default, {
    show: props.showReleaseNotes,
    useOverflow: props.useOverflow,
    title: getModuleName(moduleName, whatsNewTitle),
    subtitle: moduleName && whatsNewTitle,
    body: getBody(props),
    footer: getFooter(props),
    onHide: function onHide() {
      return setReleaseNotesItem(props);
    }
  });
};

ReleaseNotesDialog.defaultProps = {
  useOverflow: true
};
ReleaseNotesDialog.propTypes = {
  showReleaseNotes: _propTypes.default.bool.isRequired,
  setShowReleaseNotes: _propTypes.default.func.isRequired,
  whatsNewTitle: _propTypes.default.string,
  moduleName: _propTypes.default.string,
  closeButtonText: _propTypes.default.string,
  translatedReleaseNotes: _propTypes.default.object,
  currentVersion: _propTypes.default.string.isRequired,
  RELEASE_NOTES_ITEM: _propTypes.default.string.isRequired,
  useOverflow: _propTypes.default.bool
};
var _default = ReleaseNotesDialog;
exports.default = _default;